export function showActivityIndicator() {
    document.getElementById('loadingDiv').style.visibility = 'visible'
}

export function hideActivityIndicator() {
    document.getElementById('loadingDiv').style.visibility = 'hidden'
}